import React from "react";
import { Rings } from "react-loader-spinner";

export default () => (
  <div className="center">
    <Rings color="#72BA49" height={260} width={260} />
  </div>
);
